import { Injectable, signal } from '@angular/core';
import { UserRequest } from '@case-editor/models';

@Injectable({
  providedIn: 'root'
})
export class UserRequestsService {
  readonly #userRequest = signal<UserRequest | null>(null);

  readonly userRequest = this.#userRequest.asReadonly();

  updateUserRequest(userRequest: UserRequest) {
    this.#userRequest.update(state => ({ ...state, ...userRequest }));
  }

  setUserRequest(request: UserRequest | null) {
    this.#userRequest.set(request);
  }
}
